export const API_VERSION = 'v1';

const appEnv = import.meta.env.VITE_APP_ENV || 'local';

const getBackendDomain = () => {
  switch (appEnv) {
    case 'prod':
      return 'https://api.somospapo.com';
    case 'staging':
      return 'https://api-staging.somospapo.com';
    case 'dev':
      return 'https://api-dev.somospapo.com';
    default:
      // For local development, use empty string to go through Vite proxy
      return '';
  }
};

export const API_CONFIG = {
  baseURL: getBackendDomain(),
  version: API_VERSION,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
};

export const getApiUrl = (path: string): string => {
  return `/api/${API_VERSION}${path}`;
};

export const getFullApiUrl = (path: string): string => {
  return `${API_CONFIG.baseURL}${getApiUrl(path)}`;
}; 